import { ActionTree } from "vuex";
import { DeviceActionsTypes, DeviceMutationsTypes } from "./types";
import { Device, DeviceActions, DeviceState, DeviceByDay, MultipleUpdateInfo } from "./interface";
import Client from "@/plugins/axios/axios";
import { Response_ } from "@/plugins/axios/response";

export const actions: ActionTree<DeviceState, DeviceState> & DeviceActions = {
  [DeviceActionsTypes.LIST_DEVICE]: async ({ commit }): Promise<number> => {
    const last_update = sessionStorage.getItem("last_update") ?? "";
    return Client.get<number, Response_>(`material/?last_update=${last_update}`)
      .then((response: Response_) => {
        if (last_update !== "") commit(DeviceMutationsTypes.UPDATE_MULTIPLE_DEVICE, response.body as Array<Device>);
        else commit(DeviceMutationsTypes.SET_DEVICE, response.body as Array<Device>);
        return response.status;
      })
      .catch((err) => err);
  },
  [DeviceActionsTypes.LIST_DEVICE_BY_DAY]: async ({ commit }): Promise<number> => {
    return Client.get<number, Response_>(`material/device_by_days`)
      .then((response: Response_) => {
        commit(DeviceMutationsTypes.SET_DEVICE_BY_DAY, response.body as Array<DeviceByDay>);
        return response.status;
      })
      .catch((err) => err);
  },
  [DeviceActionsTypes.ARCHIVE_DEVICE]: async ({ commit }, name: string): Promise<number> => {
    return Client.delete<number, Response_>(`material/delete/${name}`)
      .then((response: Response_) => {
        commit(DeviceMutationsTypes.REMOVE_DEVICE, name);
        return response.status;
      })
      .catch((err) => err);
  },
  [DeviceActionsTypes.GET_DEVICE]: async ({ commit }, id: string): Promise<number> => {
    return Client.get<number, Response_>(`material/${id}`)
      .then((response: Response_) => {
        commit(DeviceMutationsTypes.GET_DEVICE, response.body as Device);
        return response.status;
      })
      .catch((err) => err);
  },
  [DeviceActionsTypes.CREATE_DEVICE]: async ({ commit }, device_date: any): Promise<Response_> => {
    return Client.post<Response_, Response_>(`material/`, device_date)
      .then((response: Response_) => {
        commit(DeviceMutationsTypes.CREATE_DEVICE, response.body as Device);
        return response;
      })
      .catch((err: Response_) => err);
  },
  [DeviceActionsTypes.UPDATE_DEVICE]: async (
    { commit },
    { device_data: device_data, _id: _id }
  ): Promise<Response_> => {
    delete device_data._id;
    return Client.put<Response_, Response_>(`material/${_id}`, device_data)
      .then((response) => {
        commit(DeviceMutationsTypes.UPDATE_DEVICE, response.body as Device);
        return response;
      })
      .catch((err: Response_) => err);
  },
  [DeviceActionsTypes.UPDATE_MULTIPLE_DEVICE]: async (
    { commit },
    update_info: MultipleUpdateInfo
  ): Promise<Response_> => {
    return Client.put<Response_, Response_>(`material/multiple/update`, update_info)
      .then((response) => {
        commit(DeviceMutationsTypes.UPDATE_MULTIPLE_DEVICE, response.body as Array<Device>);
        return response;
      })
      .catch((err: Response_) => err);
  },
  [DeviceActionsTypes.UPDATE_ADMIN_DEVICE]: async (
    { commit },
    { device_data: device_data, _id: _id }
  ): Promise<Response_> => {
    delete device_data._id;
    return Client.put<Response_, Response_>(`material/admin/${_id}`, device_data)
      .then((response) => {
        commit(DeviceMutationsTypes.UPDATE_DEVICE, response.body as Device);
        return response;
      })
      .catch((err: Response_) => err);
  },
  [DeviceActionsTypes.CREATE_MULTIPLE_DEVICE]: async ({ commit }, device_data): Promise<Response_> => {
    return Client.post<Response_, Response_>(`material/multiple`, device_data)
      .then((response) => {
        commit(DeviceMutationsTypes.SET_MULTIPLE_DEVICE, response.body as Array<Device>);
        return response;
      })
      .catch((err: Response_) => err);
  }
};
